export const getNumberOfPixels = (stringValue) => {
  return +stringValue.slice(0, stringValue.indexOf('p'));
};
